import ProfileIcon from '~/assets/icons/new/profile.svg?react';
import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import { ACCOUNT_PROFILE_PERSONAL_PATH } from '~/common/models/pages/accountPages.model';

export const getProfileNavBarItems = () => [
  {
    label: translateText('account:profile'),
    testId: 'account-profile-header',
    icon: <ProfileIcon className="noFill" />,
    path: ACCOUNT_PROFILE_PERSONAL_PATH,
  },
];
